import {
  QuestNavigationMenu,
  QuestNavigationMenuDisplayList,
  QuestNavigationMenuPath,
  QuestNavigationMenuText,
} from '@diritto/common/navigation/constant';
import styled from '@emotion/styled';
import { ContentBodyPadding, GNBSubMenuHeight, MaxContentBodySize } from 'constants/layout';
import { LineSubMenu } from 'ui-components/navigations/LineSubMenu';

export const QuestNavigationBar = ({ selectedMenu }: { selectedMenu: QuestNavigationMenu }) => (
  <StyledContainer>
    <StyledSubMenu
      menuList={QuestNavigationMenuDisplayList}
      menuPath={QuestNavigationMenuPath}
      menuText={QuestNavigationMenuText}
      selectedMenu={selectedMenu}
    />
  </StyledContainer>
);

const StyledContainer = styled.div`
  width: 100%;
  height: ${GNBSubMenuHeight}px;
  position: relative;
  display: flex;
  padding: 0 ${ContentBodyPadding}px;
  max-width: ${MaxContentBodySize}px;
`;

const StyledSubMenu = styled(LineSubMenu)`
  position: relative;
  top: 0;
  left: 0;
`;
